import React from "react";
import { Stack } from "@mui/material";

import ColumItem from "./ColumItem";
import { ASD_SEVERITY, ADDITIONAL_DIAGNOSES } from "./selectValues";
/**
 * @typedef {import("api/typesDef").Diagnosis} Diagnosis
 * @typedef {import("./DiagnosticFormValues").DiagnosticFormValues} DiagnosticFormValues
 */

const AUTISM_DIAGNOSES_CODE = "F84.0";

const asdSeverityLabel = (asdSeverity) =>
  ASD_SEVERITY.find((severity) => severity.value === asdSeverity)?.label;

/**
 * The `DiagnosticDetail` component displays the diagnostic profile of a client.
 * @param {Object} props - The props of the component
 * @param {DiagnosticFormValues} props.diagnosticValues - The diagnostic values of the component
 * @param {Diagnosis[]} props.listOfDiagnosis - The list of diagnosis of the component
 * @returns {React.ReactElement} The DiagnosticDetail component
 */
const DiagnosticDetail = ({ diagnosticValues, listOfDiagnosis }) => {
  const {
    diagnosisId,
    diagnosisDate,
    additionalDiagnoses,
    medicalDiagnoses,
    asdSeveritySocial,
    asdSeverityRestricted,
    iqTest,
    iqScore,
    cars2Type,
    cars2TScore,
    treatmentModality,
  } = diagnosticValues;

  const findDiagnosisById = (diagnosisId) => {
    return listOfDiagnosis.find((diagnosis) => diagnosis.id === diagnosisId);
  };

  const diagnosis = findDiagnosisById(diagnosisId);

  const asdSeveritySocialLabel = asdSeverityLabel(asdSeveritySocial);
  const asdSeverityRestrictedLabel = asdSeverityLabel(asdSeverityRestricted);

  return (
    <Stack direction={{ xs: "column", sm: "row" }} columnGap={5} rowGap={7} flexWrap="wrap">
      <ColumItem label="Diagnosis" value={diagnosis?.label} />
      <ColumItem label="Diagnosis Date (Primary)" value={diagnosisDate?.toLocaleDateString()} />

      <ColumItem
        label="Additional Diagnoses (Mental Health and Neurodevelopmental)"
        value={additionalDiagnoses
          ?.map((diagnosis) => ADDITIONAL_DIAGNOSES.find((d) => d.code === diagnosis)?.label)
          ?.join(", ")}
      />
      <ColumItem label="Medical Diagnoses" value={medicalDiagnoses.join(", ")} />

      {diagnosis?.code === AUTISM_DIAGNOSES_CODE && (
        <>
          <ColumItem label="ASD Severity - Social Communication" value={asdSeveritySocialLabel} />
          <ColumItem
            label="ASD Severity - Restricted, Repetitive Behaviors"
            value={asdSeverityRestrictedLabel}
          />
        </>
      )}

      <ColumItem label="IQ Test on File" value={iqTest} />
      <ColumItem label="Full Scale IQ Score" value={iqScore} />

      <ColumItem label="CARS-2 Type" value={cars2Type} />
      <ColumItem label="CARS-2 T-Score" value={cars2TScore} />

      <ColumItem label="Treatment Modality" value={treatmentModality} />
    </Stack>
  );
};

export default DiagnosticDetail;
